import React from 'react';
import Modal from '../shared/RespModal';
import icon from '../../assets/images/success.svg';
import Button from '../shared/Button';
import '../../css/shared/SuccessModal.css';
class SuccessModal extends React.Component {
    render() {
        return (
            <Modal hasOpen={this.props.hasOpen}>
                <div className="confirmedModalDiv">
                    <img src={icon} width="60" height="60" alt="" className="successIcon" />
                    {this.props.children}
                    <Button
                        type="button"
                        class="okbtn"
                        onClick={this.props.onClick}
                    >OK</Button>
                </div>
            </Modal>
        );
    }
}
export default SuccessModal;